<template>
  <div id="app">
    <div class="container py-4 cv-container">
      <header class="d-flex flex-wrap justify-content-center py-3 mb-4 border-bottom header-namespace">
        <a href="/" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none">
          <span class="fs-3 title-namespace">Younggeol Cho</span>
        </a>

        <ul class="nav nav-pills justify-content-center nav-menu-btn">
          <!--        <li class="nav-item"><a href="/" class="nav-link active">Home</a></li>-->
          <router-link to="/cv/">
            <li class="nav-item active"><a class="nav-link nav-item-about" @click="view_item('about')">About</a></li>
          </router-link>
          <router-link to="/cv/publications">
            <li class="nav-item"><a class="nav-link nav-item-pub" @click="view_item('publications')">Publications</a></li>
          </router-link>
          <router-link to="/cv/works">
            <li class="nav-item"><a class="nav-link nav-item-works" @click="view_item('works')" >Works</a></li>
          </router-link>
          <router-link to="/cv/experiences">
            <li class="nav-item"><a class="nav-link nav-item-exp" @click="view_item('experiences')">Experiences</a></li>
          </router-link>
          <router-link to="/cv/extras">
            <li class="nav-item"><a class="nav-link nav-item-extra" @click="view_item('extras')">ExtraInfo</a></li>
          </router-link>
        </ul>
      </header>

      <div class="main-content">
        <div class="container cv-content">
          <div class="cv-element" v-for="e in contents">
            <div class="cv-title" v-if="e.type !== 'hidden'">
              {{e.title}}
              <span v-html="attach_badge(e.icon)"></span>
              <span v-if="e.tooltip && !showModal" v-tooltip="{content: e.tooltip, placement:'right', show: true, trigger: 'manual'}"></span>

<!--              <div class="tooltip show bs-tooltip-end" role="tooltip" id="tooltip699529" data-popper-placement="right" style="position: absolute; margin: 0px; transform: translate(100px, -30px);">-->
<!--                <div class="tooltip-arrow" style="position: absolute; top: 0px; transform: translate(0px, 8px);"></div>-->
<!--                <div class="tooltip-inner">test</div>-->
<!--              </div>-->

            </div>
<!--            <span data-bs-toggle="tooltip" data-bs-placement="right" data-bs-trigger="manual" title="test">test</span>-->



            <table class="table table-borderless table-sm" v-if="e.type === 'table' || e.type === 'listed-table'">
              <tr v-for="row in e.content">
                <td class="listed-table-head" :class="e.style_title" v-html="(row[lang] ? row[lang][0] : row[0])" v-if="e.type === 'listed-table'"></td>
                <td :class="e.style_title" v-html="row[lang] ? row[lang][0] : row[0]" v-else></td>
                <td :class="e.style_content" v-html="row[lang] ? row[lang][1] : row[1]"></td>
              </tr>
            </table>
            <ul v-else-if="e.type === 'list'">
              <li v-for="row in e.content" class="info-list-row">
                <span :class="e.style_title" v-html="row[lang] ? row[lang][0] : row[0]"></span>
                <span :class="e.style_content" v-html="row[lang] ? row[lang][1] : row[1]"></span>
              </li>
            </ul>
            <ul v-else-if="e.type === 'publication' || e.type === 'patent'">
              <li class="publication-row" v-for="row in e.content">
                <span class="publication-title">
                  <a v-if="row.link" :href="row.link">
                    {{row.title[lang] || row.title.en || row.title}}
                  </a>
                  <span v-else>{{row.title[lang] || row.title.en || row.title}}</span>
                </span>
                <span v-html="attach_badge(row.icon)"></span>
                <span v-if="row.index" v-html="badge({style: `bgc-index-${row.index}`, content: row.index}, 'status')"></span>
                <br>
                <span class="publication-author" v-if="e.type === 'publication'">
                  <span v-html="row.author[lang] || row.author.en || row.author"></span>
                </span>
                <span class="publication-author" v-else>
                  <span v-html="row.author[lang] || row.author.en || row.author" class="tooltip-underline" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="row.holder ? 'Inventor' : 'Inventor & Applicant'"></span><span v-if="row.holder">;</span>
                  <span class="tooltip-underline" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Applicant">{{row.holder[lang] || row.holder || row.holder || ''}}</span>
                </span>
                  <br>
                <span class="publication-journal" v-if="e.type === 'publication'">
                  {{row.journal[lang] || row.journal.en || row.journal}}, {{row.page}}<template v-if="row.etc">{{row.etc}}</template>, {{row.year}}
                  <span v-if="row.under_review" v-html="badge({style: 'bgc-under-review', content: 'under review'}, 'status')"></span>
<!--                  <span class="badge rounded-pill badge-rounded bgc-year">{{row.year}}</span>-->
                  <a v-if="row.doi" :href="'https://doi.org/' + row.doi">
                    <br>DOI: {{row.doi}}
                  </a>
                  <a v-if="row.link" :href="row.link" class="ext-link">
                    <i class="fas fa-external-link-alt"></i>
                  </a>
                </span>
                <span class="publication-journal" v-else>
                  <span data-bs-toggle="tooltip" data-bs-placement="bottom" :title="row.reg_no?'Registered':'Pending'">
                    <span v-if="row.reg_no">Registration No. {{row.reg_no}}</span>
                    <span v-else-if="row.app_no">Application No. {{row.app_no}}</span>
                  </span>, {{row.year}}
                  <a v-if="row.link" :href="row.link" class="ext-link">
                    <i class="fas fa-external-link-alt"></i>
                  </a>
                  <span v-if="row.status" v-html="badge({style: row.style_badge, content: row.status}, 'status')"></span>
<!--                  <a v-if="row.doi" :href="'https://doi.org/' + row.doi">-->
<!--                    <br>DOI: {{row.doi}}-->
<!--                  </a>-->

<!--                  <span v-html="badge(row.year, 'year')"></span>-->

<!--                  <span class="badge rounded-pill badge-rounded bgc-status" :class="row.style_badge">{{row.status}}</span>-->
<!--                  <span class="badge rounded-pill badge-rounded bgc-year">{{row.year}}</span>-->
              </span>
                <br>
              </li>
            </ul>
            <ul v-else-if="e.type === 'work'">
              <li v-for="row in e.content" class="info-list-row">
                <span class="work-position">{{row.position[lang] || row.position}} </span>
                @ {{row.at[lang] || row.at}}<span v-if="row.description">
                  <span v-html="attach_badge(row.icon, '&nbsp;')"></span>
                  <br>{{row.description[lang] || row.description}}</span>,
                {{parse_date(row.date, lang)}}
                <span v-html="attach_badge(row.icon, '&nbsp;')" v-if="!row.description"></span>
              </li>
            </ul>
<!--            <table class="table table-borderless table-sm" v-else-if="e.type === 'work'">-->
<!--              <tr v-for="row in e.content">-->
<!--                <td class="work-date" v-html="row.date[lang] || row.date"></td>-->
<!--                <td :class="e.style_content">-->
<!--                  <span class="work-at">{{row.at[lang] || row.at}}</span> <br>-->
<!--                  <span class="work-position">-->
<!--                    {{row.position[lang] || row.position}}-->
<!--                  </span>-->
<!--                  <span class="badge badge-rounded bgc-research" v-if="row.icon && row.icon.includes('researcher')">researcher</span>-->
<!--                  <span class="badge badge-rounded bgc-developer" v-if="row.icon && row.icon.includes('developer')">developer</span>-->
<!--                  <span class="badge badge-rounded bgc-maker" v-if="row.icon && row.icon.includes('maker')">maker</span>-->
<!--                  <span class="badge badge-rounded bgc-instructor" v-if="row.icon && row.icon.includes('instructor')">instructor</span>-->
<!--                  <br>-->

<!--                  <span class="work-description">{{row.description[lang] || row.description}}</span>-->
<!--                </td>-->
<!--              </tr>-->
<!--            </table>-->
            <table class="table table-borderless table-sm" v-else-if="e.type === 'activity'">
              <tr v-for="row in e.content">
                <td class="work-date" v-html="row.date[lang] || row.date"></td>
                <td :class="e.style_content">
                  <span class="work-at">{{row.at[lang] || row.at}}</span> <br>
                  <span class="work-position">
                    {{row.position[lang] || row.position}}
                  </span>
                  <span class="badge badge-rounded bgc-research" v-if="row.icon && row.icon.includes('researcher')">researcher</span>
                  <span class="badge badge-rounded bgc-developer" v-if="row.icon && row.icon.includes('developer')">developer</span>
                  <span class="badge badge-rounded bgc-maker" v-if="row.icon && row.icon.includes('maker')">maker</span>
                  <span class="badge badge-rounded bgc-instructor" v-if="row.icon && row.icon.includes('instructor')">instructor</span>
                  <br>
                </td>
              </tr>
            </table>
            <table class="table table-borderless table-sm" v-else-if="e.type === 'exp-table'">
              <tr v-for="row in e.content">
                <td :class="e.style_title">{{row.date[lang] || row.date}}</td>
                <td :class="e.style_content">
                  <span v-html="row.title[lang] || row.title"></span>
                  <span v-html="attach_badge(row.icon)"></span>
                </td>
              </tr>
            </table>
            <ul v-else-if="e.type === 'exp-list'">
              <li class="info-list-row" v-for="row in e.content">
                <span :class="e.style_title" v-html="row.title[lang] || row.title" @click="openModal(e.id, {...row})"></span><span :class="e.style_content" v-if="row.description" v-html="attach_badge(row.icon, '&nbsp;') + '<br>' + (row.description[lang] || row.description)"></span>,
                <span :class="e.style_content">{{parse_date(row.date, lang)}}</span>
                <span v-html="attach_badge(row.icon)" v-if="!row.description"></span>
              </li>
            </ul>

            <ul v-else-if="e.type === 'obj-list'">
              <li class="publication-row" v-for="row in e.content">
                <span style="margin-right: 3px" v-if="lang === 'ko'">
                  {{row.by[lang] || (row.by[lang] === "" ? "" : row.by)}}
                  {{row.at[lang] || (row.at[lang] === "" ? "" : row.at)}}
                  {{row.prize[lang] || row.prize}},
                  {{parse_date(row.date, lang)}}
                </span>
                <span style="margin-right: 3px" v-else>
                  {{row.prize[lang] || row.prize}},
                  {{row.at[lang] ? (row.at[lang] + ',')
                                 : (row.at[lang] === "" ? "" : (row.at + ','))}}
                  {{row.by[lang] ? (row.by[lang] + ',')
                                 : (row.by[lang] === "" ? "" : (row.by + ','))}}
                  {{parse_date(row.date, lang)}}
                </span>
                <span v-html="attach_badge(row.icon)"></span>
              </li>
            </ul>
            <div v-else>
              <p v-for="row in e.content">
                <span :class="e.style_title" v-html="row[lang] ? row[lang][0] : row[0]"></span>
                <span :class="e.style_content" v-html="(row[lang] ? row[lang][1] : row[1]) || ''"></span>
              </p>
            </div>
          </div>
        </div>
      </div>


      <footer class="div-footer mt-4 text-muted border-top">
        <span v-html="badge('developer', 'work.button' + (work_badges['developer'] ? '' : '.disabled'))" @click="toggle_badge('developer')"></span>
        <span v-html="badge('researcher', 'work.button' + (work_badges['researcher'] ? '' : '.disabled'))" @click="toggle_badge('researcher')"></span>
        <span v-html="badge('instructor', 'work.button' + (work_badges['instructor'] ? '' : '.disabled'))" @click="toggle_badge('instructor')"></span>
        <span v-html="badge('maker', 'work.button' + (work_badges['maker'] ? '' : '.disabled'))" @click="toggle_badge('maker')"></span>

        <button class="btn btn-transparent" :title="version ? 'Last updated: ' + this.version_string() : ''" @click="view_item('rangewing')">&nbsp;&nbsp;</button>
        <!--        &copy; <span :title="version ? 'Last updated: ' + this.version_string() : ''">2021</span> Younggeol Cho <router-link to="/cv/rangewing"><span @click="view_item('rangewing')">(RangeWING) at wingdev.kr</span> </router-link>-->
<!--        <span class="pull-right">-->
<!--          <button type="button" class="btn btn-sm btn-light btn-white text-muted" v-if="lang === 'en'" @click="change_lang('ko')">한국어</button>-->
<!--          <button type="button" class="btn btn-sm btn-light btn-white text-muted" v-else @click="change_lang('en')">English</button>-->
<!--        </span>-->

        <div class="btn-group dropup pull-right">
          <transition name="fade">
            <span v-if="!showModal && showLangTooltip" v-tooltip="{content: (lang === 'en' ? 'Korean' : 'English') + ' version available', placement:'left', show: true, trigger: 'manual'}"></span>
          </transition>
          <button type="button" class="btn btn-white btn-footer btn-footer-dropdown text-muted dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Language: <span v-if="lang === 'en'">English</span> <span v-else>한국어</span>
          </button>
          <div class="dropdown-menu">
            <a class="dropdown-item" @click="change_lang('ko')">한국어</a>
            <a class="dropdown-item" @click="change_lang('en')">English</a>
          </div>
        </div>



      </footer>
    </div>

    <modal :show="showModal" @close="showModal = false">
      <div slot="header">
        <h3 v-html="modalContent.header"></h3>
        <span class="text-muted" v-html="modalContent.subtitle"></span>
      </div>
      <div class="row" slot="content" style="margin-top: 12px">
        <div class="col-md-6 col-lg-7">
<!--          <img class="img-fluid" :src="(modalContent.content.images || ['https://via.placeholder.com/640x640'])[0]">-->

          <div id="carouselModalImage" class="carousel slide" data-bs-interval="false">
            <div class="carousel-inner mh-100">
              <div class="carousel-item active">
                <CarouselContent :content="(modalContent.content.images || ['https://via.placeholder.com/640x480'])[0]"></CarouselContent>

<!--                <a :href="(modalContent.content.images || ['https://via.placeholder.com/640x480'])[0]"  target="_blank">-->
<!--                  -->
<!--                  <img :src="(modalContent.content.images || ['https://via.placeholder.com/640x480'])[0]"-->
<!--                       class="d-block mw-100 carousel-img">-->
<!--                </a>-->
              </div>
              <div class="carousel-item" v-for="img in (modalContent.content.images||[]).slice(1)">
                <CarouselContent :content="img"></CarouselContent>
<!--                <a :href="img" target="_blank">-->
<!--                  <img :src="img" class="d-block mw-100 carousel-img">-->
<!--                </a>-->
              </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselModalImage" data-bs-slide="prev" v-if="modalContent.content.images && modalContent.content.images.length > 1">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselModalImage" data-bs-slide="next" v-if="modalContent.content.images && modalContent.content.images.length > 1">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="col-md-6 col-lg-5 detail-desc">
          <div v-html="i18n(modalContent.content.description)"></div>
          <hr>
          <div>
            <table class="table table-borderless table-sm w-100">
              <tr v-for="row in modalContent.content.contents" class="tr-detail">
                <td style="word-break: normal">
                  <b>{{ row[0] }}</b>
                </td>
                <td>
                  <span v-if="row[1].startsWith('http')">
                    <a :href="row[1]" target="_blank">
                      {{ row[1] }}
                      <i class="fas fa-external-link-alt"></i>
                    </a>
                  </span>
                  <span v-else>
                    {{ row[1] }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

import Modal from "./Modal";
import CarouselContent from "./CarouselContent";

const API_URL = process.env.VUE_APP_BASE_URL + '/cv/~data'
const PUBLIC_URL = process.env.VUE_APP_BASE_URL

export default {
  name: 'CV',
  components: {
    CarouselContent,
    Modal
  },
  data() {
    return {
      lang: "en",
      item: this.$route.params.item || 'about',
      contents: undefined,
      contents_map: undefined,
      version: undefined,
      work_badges: {
        developer: true,
        researcher: true,
        instructor: true,
        maker: true
      },
      showModal: false,
      showTooltip: true,
      modalContent: {
        header: "",
        content: ""
      },
      showLangTooltip: false
    }
  },
  methods: {
    change_lang(lang) {
      this.lang = lang;
    },
    i18n(text, defaultstring){
      return text ? (text[this.lang] || text) : defaultstring
    },
    view_item(item) {
      if(this.contents_map && !(item in this.contents_map)) {
        item = '404'
      }

      this.item = item;
      this.contents = this.contents_map[item]
    },
    load() {
      return axios.get(API_URL)
          .then(resp => {
            this.contents_map = resp.data
          })
    },
    load_version() {
      return axios.get(`${API_URL}/version`)
        .then(resp => {
          if(resp.data)
            this.version = resp.data
            for(const key in this.version) {
              this.version[key] = moment.utc(this.version[key]).local().format("YYYY-MM-DD HH:mm:ss")
            }
        })
    },
    version_string() {
      if(this.version) {
         return `${this.version['content']} (Content), ${this.version['layout']} (Layout)`
      }else return undefined
    },
    attach_badge(icon, prefix) {
      icon = icon || []
      prefix = prefix || ''

      const ICONS = Object.keys(this.work_badges)
      let html = prefix
      for(const ic of ICONS) {
        if(icon.includes(ic)) {
          html += this.badge(ic, 'work')
        }
      }
      return html
    },
    badge(data, type) {
      type = type || 'custom'
      const _type = type.split('.')
      type = _type[0]

      if(type === 'work') {
        const disabled = _type.includes('disabled')
        const button = _type.includes('button')
        if(disabled || this.work_badges[data]) {
          return this.badge({
            style: 'bgc-' + (disabled ? 'disabled' : data),
            content: data
          }, button ? 'custombtn' : 'custom') + ' '
        }
        else return ''
        // return `<span class="badge badge-rounded bgc-${data}">${data}</span> `
      }
      else if(type === 'year') {
        return this.badge({
          style: 'bgc-year',
          content: data
        }, 'custom')
      }
      else if(type === 'status') {
        const {style, content} = data
        return this.badge({
          style: 'bgc-status ' + style,
          content
        }, 'custom')
      }
      else if(type === 'custom') {
        const {style, content} = data
        return `<span class="badge rounded-pill badge-rounded ${style}">${content}</span>`
      }
      else if(type === 'custombtn') {
        const {style, content} = data
        return `<button class="badge rounded-pill badge-rounded ${style}">${content}</button>`
      }
      return ''
    },
    parse_date(dt, lang) {
      lang = lang || 'en'

      let format = 'MMM. YYYY'
      if(lang === 'ko') {
        format = 'YYYY.MM.'
      }
      return this._parse_date(dt, format, '  – ')
    },
    _parse_date(date, fmt, mid) {
      date = date || ''
      fmt = fmt || 'MMM. YYYY'
      mid = mid || ' – '
      if(Array.isArray(date)) {
        const from = moment(date[0]).format(fmt)
        const to = moment(date[1]).format(fmt)
        return `${from}${mid}${to}`
      }
      return moment(date).format(fmt)
    },
    toggle_badge(badge) {
      this.work_badges[badge] = !this.work_badges[badge]
    },
    openModal(cat, row) {
      this.modalContent.header = this.i18n(row.title)
      this.modalContent.subtitle = this.i18n(row.description) + ', ' + this.parse_date(row.date)
      this.modalContent.content = {
        "description": "Description not available"
      }

      if(row.id) {
        cat = 'detail/' + cat
        this.showModal = true;
        const cnt = this.contents_map[cat][row.id]
        this.modalContent.content = cnt

        if(cnt && cnt.images) {
          cnt.images = cnt.images ?
            cnt.images.map(
              e => {
                let url = e.startsWith('/') ? (PUBLIC_URL + e) : e
                let type = 'image'
                if (url.includes(".webm")) {
                  type = 'video'
                } else if (url.includes('youtube.com/embed')) {
                  type = 'iframe'
                }
                return {type, url};
              }
            ) : ['https://via.placeholder.com/640x480']

          this.modalContent.subtitle = this.i18n(cnt.subtitle || row.description) + ', ' + this.parse_date(row.date)
          this.modalContent.content = cnt
        }
      }
    }
  },
  created() {
  },
  mounted() {
    this.load().then(() => this.view_item(this.$route.params.item || 'about'))
    this.load_version()

    setTimeout(() => {
      this.showLangTooltip = true
    }, 800)

  },
  beforeDestroy() {
  }
}
</script>

<style>
#app {
}

body {
  /*overflow: auto;*/
}

div.carousel-detail {
  /*height: 480px;*/
}

.carousel-img {
  max-height: 480px;
  margin: auto;
}

.carousel-inner {
  margin: auto;
}

.tr-detail {
  height: 2.1rem;
  vertical-align: top;
  overflow-wrap: break-word;
  word-break: break-all;
}

.detail-desc {
  /*overflow-wrap: break-word;*/
  /*word-break: break-all;*/
}


hr {
  margin: 0.5rem 0;
}

td.listed-table-head {
  vertical-align: baseline;
}

.btn-outline-gray {
  border-color: #c0d2e0;
  color: #9ba9b4!important;
}

.btn-white {
  border-color: #ffffff;
  background-color: #ffffff;
}

.pull-right {
  float: right;
}

.btn-footer-dropdown {
  padding-top: 0;
  padding-bottom: 0;
}

.nav-link {
  color: inherit!important;
}

.carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23bbb'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")
}

.carousel-control-prev-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23bbb'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")
}

/*.dropup .dropdown-toggle::after {*/
/*  vertical-align: middle;*/
/*}*/

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>



// WEBPACK FOOTER //
// src/components/CV.vue